import { c as _c } from "react/compiler-runtime";
import logoB from "@/assets/logoB.png";
import logoL from "@/assets/logoL.png";
import logoR from "@/assets/logoR.png";
import { OptimizedImage } from "@/components/OptimizedImage";
export const SidebarBackground = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="overflow-hidden"><div className="z-10 overflow-hidden"><OptimizedImage src={logoR} alt={"Logo d\xE9coratif droite"} width={45} height={45} className="absolute bottom-36 right-0" /><OptimizedImage src={logoB} alt={"Logo d\xE9coratif bas"} width={45} height={45} className="absolute bottom-0 right-0" /><OptimizedImage src={logoL} alt={"Logo d\xE9coratif gauche"} width={105} height={45} className="absolute bottom-0 left-0" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};